import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Loader2, AlertTriangle, ArrowLeft } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { api, formatApiErrorDetail } from "@/lib/api";
import Signup from "@/pages/Signup";

export default function Join() {
  const { token } = useParams();
  const [state, setState] = useState({ loading: true, businessName: null, error: "" });

  useEffect(() => {
    api
      .validateInvite(token)
      .then((data) => setState({ loading: false, businessName: data.business_name, error: "" }))
      .catch((err) =>
        setState({
          loading: false,
          businessName: null,
          error: formatApiErrorDetail(err.response?.data?.detail) || "Invalid invitation link",
        })
      );
  }, [token]);

  if (state.loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  if (state.error) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background px-4">
        <Card className="w-full max-w-md rounded-2xl border-border p-8 text-center">
          <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-rose-100">
            <AlertTriangle className="h-7 w-7 text-rose-600" />
          </div>
          <h1 className="mt-4 font-display text-2xl font-extrabold text-foreground">
            Invitation not valid
          </h1>
          <p className="mt-2 text-sm text-muted-foreground" data-testid="join-error">
            {state.error}
          </p>
          <Button
            onClick={() => (window.location.href = "/login")}
            data-testid="join-error-back-btn"
            className="mt-6 h-12 w-full rounded-xl font-bold"
          >
            <ArrowLeft className="mr-2 h-4 w-4" /> Go to Log in
          </Button>
        </Card>
      </div>
    );
  }

  return <Signup inviteToken={token} businessName={state.businessName} />;
}
